import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import { GetSearchUrl } from '../../Utils/utils';
import useBreakpoint from '../../Hooks/useBreakpoint';
import usePrevious from '@react-hook/previous';
import clsx from 'clsx';

const SearchCard = (props) => {
  const { id, local_article_number, name, local_name, boxQuantity, url, parentCategory, isSelected } = props;
  const ariaLabel = translate('product.view-product.sc') + ' ' + local_name;

  debugger;

  return (
    <div
      className={clsx(
        'clerk-search-card',
        isSelected && 'clerk-search-card--selected'
      )}
    >
      <div className="clerk-search-card__top">
        <a className="clerk-search-card__title" href={url}>
          {local_name}
        </a>
        {parentCategory && (
          <div className="clerk-search-card__description">{parentCategory}</div>
        )}
        <div className="clerk-search-card__artno-and-units">
          {id && (
            <a className="clerk-search-card__artno" href={url}>
              {translate('product.artno')}: {local_article_number}
            </a>
          )}
          {boxQuantity && (
            <div className="clerk-search-card__units">
              {translate('product.units')}: {boxQuantity}
            </div>
          )}
        </div>
      </div>
      <div className="clerk-search-card__bottom">
        <a
          className="clerk-search-card-list__button"
          href={url}
          aria-label={ariaLabel}
        >
          {translate('product.view-product')}
        </a>
      </div>
    </div>
  );
};

const SearchCardList = (props) => {
  const { id, local_article_number, name, local_name, boxQuantity, url, parentCategory, isSelected } = props;
  const ariaLabel = translate('product.view-product.sc') + ' ' + local_name;

  return (
    <div
      className={clsx(
        'clerk-search-card-list',
        isSelected && 'clerk-search-card-list--selected'
      )}
    >
      <div className="clerk-search-card-list__left">
        <div className="clerk-search-card-list__col clerk-search-card-list__col--desc">
          <a
            className="clerk-search-card-list__title"
            href={url}
            aria-label={ariaLabel}
          >
            {local_name}
          </a>
          {parentCategory && (
            <div className="clerk-search-card-list__category">
              {parentCategory}
            </div>
          )}
        </div>
      </div>
      <div className="clerk-search-card-list__right">
        <div className="clerk-search-card-list__col clerk-search-card-list__col--artno">
          <a className="clerk-search-card-list__artno-col" href={url}>
            {local_article_number}
          </a>
        </div>
        <div className="clerk-search-card-list__col clerk-search-card-list__col--units">
          <div className="clerk-search-card-list__units-col">
            {translate('product.pieces-with-quantity').replace(
              '{0}',
              boxQuantity
            )}
          </div>
        </div>
        <div className="clerk-search-card-list__col clerk-search-card-list__col--actions">
          <a
            className="clerk-search-card-list__button"
            href={url}
            aria-label={ariaLabel}
          >
            {translate('product.view-product')}
          </a>
        </div>
      </div>
    </div>
  );
};

const QuickSearchProductCard = (props) => {
  const currentBreakpoint = useBreakpoint();

  return currentBreakpoint === 'sm' ? (
    <SearchCard {...props} />
  ) : (
    <SearchCardList {...props} />
  );
};

const HitAsLink = (props) => {
  const { name, local_name, url } = props;

  return (
    <li>
      <a href={url}>{local_name}</a>
    </li>
  );
};

const HitAsListProductCard = (props) => {
  const { id, local_article_number, name, local_name, box_quantity, url, description, isSelected } = props;

  return (
    <QuickSearchProductCard
      id={id}
      local_article_number={local_article_number}
      name={name}
      local_name={local_name}
      boxQuantity={box_quantity}
      url={url}
      parentCategory={description}
      isSelected={isSelected}
    />
  );
};

const SuggestionsList = (props) => {
  const { suggestions } = props;

  return (
    <div className="clerk-quick-search-hits__results">
      <div className="clerk-quick-search-hits__results-title">
        <span>{translate('clerk.suggestions')}</span>
      </div>
      <ul className="clerk-quick-search-hits__results-hits clerk-quick-search-hits__results-hits--suggestions">
        {suggestions.map((item, i) => {
          const url = GetSearchUrl(item);
          return <HitAsLink key={i + url} name={item} url={url} />;
        })}
      </ul>
    </div>
  );
};

const CategoriesList = (props) => {
  const { categories } = props;

  return (
    <div className="clerk-quick-search-hits__results">
      <div className="clerk-quick-search-hits__results-title">
        <span>{translate('clerk.categories')}</span>
      </div>
      <ul className="clerk-quick-search-hits__results-hits clerk-quick-search-hits__results-hits--categories">
        {categories.map((category, i) => (
          <HitAsLink
            key={i + category.name}
            name={category.name}
            url={category.url}
          />
        ))}
      </ul>
    </div>
  );
};

const ProductList = (props) => {
  const { products, selectedItem } = props;
  const showProducts = products && products.length > 0;
  const currentBreakpoint = useBreakpoint();
  const isMobile = currentBreakpoint === 'sm';

  const renderProducts = () => {
    if (!showProducts) {
      return <>{translate('clerk.no-products')}</>;
    }

    const productCards = products.map((item, key) => (
      <HitAsListProductCard
        key={item.id}
        isSelected={key === selectedItem}
        {...item}
      />
    ));

    if (isMobile) {
      return <>{productCards}</>;
    }

    return (
      <div className="clerk-search-list">
        <div className="clerk-search-list__table-header">
          <div className="clerk-search-list__table-header-left">
            <div className="clerk-search-list__table-header-col clerk-search-list__table-header-col--desc">
              {translate('product.part-description')}
            </div>
          </div>
          <div className="clerk-search-list__table-header-right">
            <div className="clerk-search-list__table-header-col clerk-search-list__table-header-col--artno">
              {translate('product.artno')}
            </div>
            <div className="clerk-search-list__table-header-col clerk-search-list__table-header-col--units">
              {translate('product.units')}
            </div>
          </div>
        </div>
        {productCards}
      </div>
    );
  };

  return (
    <div className="clerk-quick-search-hits__results-wrapper">
      <div className="clerk-quick-search-hits__results clerk-quick-search-hits__results--products">
        <div className="clerk-quick-search-hits__results-title">
          <span>{translate('clerk.products')}</span>
        </div>
        <div className="clerk-quick-search-hits__results-hits">
          {renderProducts()}
        </div>
      </div>
    </div>
  );
};

const ShowAllButton = (props) => {
  const { searchUrl } = props;

  return (
    <div className="clerk-quick-search-hits__bottom">
      <a href={searchUrl} className="clerk-quick-search-hits__show-all-button">
        {translate('clerk.show-all-products')}
      </a>
    </div>
  );
};

const Hits = (props) => {
  const { searchUrl, suggestions, categories, selectedItem } = props;

  return (
    <div className="clerk-quick-search-hits">
      <div className="clerk-quick-search-hits__top">
        <div className="clerk-quick-search-hits__results-wrapper clerk-quick-search-hits__results-wrapper--other-results">
          {suggestions && suggestions.length > 0 && (
            <SuggestionsList suggestions={suggestions} />
          )}
          {categories && categories.length > 0 && (
            <CategoriesList categories={categories} />
          )}
        </div>
        <ProductList
          products={props.result?.product_data}
          selectedItem={selectedItem}
        />
      </div>
      {searchUrl && <ShowAllButton searchUrl={searchUrl} />}
    </div>
  );
};

const NoHits = () => (
  <div className="clerk-quick-search-result__no-hits">
    {translate('clerk.no-hits')}
  </div>
);

const ClerkQuickSearchResult = (props) => {
  const {
    query,
    result,
    suggestions,
    categories,
    showFullForm,
    selectedItem,
  } = useSelector((state) => state.clerk);
  const searchUrl = GetSearchUrl(query);
  const anyHits =
    result?.hits > 0 || suggestions?.length > 0 || categories?.length > 0;
  const previousSelectedItem = usePrevious(selectedItem);

  useEffect(() => {
    if (showFullForm && selectedItem !== previousSelectedItem) {
      const el = document.querySelector(
        '.clerk-search-card--selected, .clerk-search-card-list--selected'
      );
      el &&
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
    }
  }, [showFullForm, selectedItem, previousSelectedItem]);

  if (!showFullForm || !result) {
    return null;
  }

  return (
    <div
      className={clsx(
        'clerk-quick-search-result',
        !anyHits && 'clerk-quick-search-result--no-hits'
      )}
    >
      {anyHits ? (
        <Hits
          searchUrl={searchUrl}
          suggestions={suggestions}
          categories={categories}
          result={result}
          selectedItem={selectedItem}
        />
      ) : (
        <NoHits />
      )}
    </div>
  );
};

export default ClerkQuickSearchResult;
